import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import waterMeterReducer from './slices/waterMeterSlice';
import readingReducer from './slices/readingSlice';
import issueReducer from './slices/issueSlice';
import locationReducer from './slices/locationSlice';
import notificationSlice from './slices/notificationSlice';
import areaReducer from './slices/areaSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    waterMeters: waterMeterReducer,
    readings: readingReducer,
    issues: issueReducer,
    locations: locationReducer,
    notifications: notificationSlice,
    areas: areaReducer

    

  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
